import { useFormikContext } from "formik";
import "./css/components.css";
import { useTramite } from "../context/Tramite";
import { useTranslation } from "react-i18next";
import { useAuthentication } from "../context/Authentication";
import { useState } from "react";
import { isInvalid } from "../utils/forms";
import { borrarArchivo, subirArchivo } from "../api/General";
import { ARCHIVOS_ENDPOINT } from "../utils/api";
import { isFinalizado, isPresentado, isProcesado } from "../utils/tramite";
import Loader from "./controls/Loader";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import Label from "./controls/Label";
import ArrayField from "./controls/ArrayField";
import ListGroup, { ListGroupItem } from "./controls/ListGroup";
import LongTextValue from "./controls/LongTextValue";
import LinkButton from "./controls/LinkButton";
import FileField from "./controls/FileField";
import DownloadIcon from "./icon/DownloadIcon";
import TrashIcon from "./icon/TrashIcon";
import UploadIcon from "./icon/UploadIcon";

export default function AdjuntosForm({ ...props }) {
  const { tramite } = useTramite();
  const { t } = useTranslation();
  const { token } = useAuthentication();
  const tramiteForm = useFormikContext();
  const [loading, setLoading] = useState(false);
  const handleAdjuntosChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleArchivoDelete = (index) => (event) => {
    event.preventDefault();
    const archivo = tramiteForm.values.adjuntos?.[index]?.archivo;
    if (!!archivo) {
      borrarArchivo(archivo, token).then(() => {
        tramiteForm.setFieldValue(`adjuntos.${index}.archivo`, null, false);
        tramiteForm.setFieldTouched(`adjuntos.${index}`, true, true);
      });
    }
  };
  const handleArchivoChange = (index) => (event) => {
    event.preventDefault();
    const file = event.target.file;
    const archivo = tramiteForm.values.adjuntos?.[index].archivo;
    if (!!archivo) {
      borrarArchivo(archivo, token).then(() => {
        if (!!file) {
          const lector = new FileReader();
          lector.onload = () => {
            const nombre =
              tramiteForm.values.adjuntos?.[index]?.documento?.codigo;
            const tipoMIME = file.type;
            const data = lector.result;
            setLoading(true);
            subirArchivo(nombre, tipoMIME, data, token)
              .then((archivo) => {
                tramiteForm.setFieldValue(
                  `adjuntos.${index}.archivo`,
                  archivo,
                  false,
                );
                tramiteForm.setFieldTouched(`adjuntos.${index}`, true, true);
              })
              .finally(setLoading(false));
          };
          lector.readAsDataURL(file);
        }
      });
    } else {
      if (!!file) {
        const lector = new FileReader();
        lector.onload = () => {
          const nombre =
            tramiteForm.values.adjuntos?.[index]?.documento?.codigo;
          const tipoMIME = file.type;
          const data = lector.result;
          setLoading(true);
          subirArchivo(nombre, tipoMIME, data, token)
            .then((archivo) => {
              tramiteForm.setFieldValue(
                `adjuntos.${index}.archivo`,
                archivo,
                false,
              );
              tramiteForm.setFieldTouched(`adjuntos.${index}`, true, true);
            })
            .finally(setLoading(false));
        };
        lector.readAsDataURL(file);
      }
    }
  };
  const handleHistoricoClick = (index, archivo) => (event) => {
    event.preventDefault();
    tramiteForm.setFieldValue(`adjuntos.${index}.archivo`, archivo);
    tramiteForm.setFieldTouched(`adjuntos.${index}`, true, true);
  };
  const existeArchivoHistorico = (adjunto) => {
    return (
      tramite.establecimiento?.adjuntos?.findIndex(
        (value) => value.documento?.codigo === adjunto.documento?.codigo,
      ) >= 0 || false
    );
  };
  const listarArchivosHistoricos = (adjunto) => {
    const archivos = tramite.establecimiento?.adjuntos
      ?.filter(
        (value) =>
          value.documento?.codigo === adjunto.documento?.codigo &&
          !!value.archivo,
      )
      .map((documento) => documento.archivo);
    return !!archivos ? archivos : [];
  };
  return (
    <Loader loading={loading}>
      <Grid>
        <Row>
          <Col>
            <Label>{t("tramite.adjuntos")}</Label>
            <ArrayField
              id="adjuntos"
              name="adjuntos"
              value={tramiteForm.values.adjuntos}
              onChange={handleAdjuntosChange}
            >
              {({ value: adjuntos }) => (
                <ListGroup>
                  {adjuntos?.map((adjunto, index) => (
                    <ListGroupItem>
                      {!!adjunto?.archivo && (
                        <Grid>
                          <Row style={{ display: "flex", flexWrap: "wrap" }}>
                            <Col lg={10}>
                              <LongTextValue
                                label={adjunto?.documento?.nombre}
                                value={`${adjunto?.archivo?.algoritmoChequeo}: ${adjunto?.archivo?.chequeo}`}
                              />
                            </Col>
                            <Col lg={1}>
                              <LinkButton
                                sm
                                style={{ margin: 0, fontSize: "16px" }}
                                href={`${ARCHIVOS_ENDPOINT}/${adjunto?.archivo?.id}?token=${token}`}
                                download={adjunto?.archivo?.nombre}
                              >
                                <DownloadIcon />
                              </LinkButton>
                            </Col>
                            <Col lg={1}>
                              <LinkButton
                                sm
                                style={{ margin: 0, fontSize: "16px" }}
                                onClick={handleArchivoDelete(index)}
                                disabled={!isFinalizado(tramite)}
                              >
                                <TrashIcon />
                              </LinkButton>
                            </Col>
                          </Row>
                        </Grid>
                      )}
                      {!adjunto?.archivo && (
                        <Grid>
                          <Row>
                            <Col>
                              {!adjunto?.archivo && (
                                <FileField
                                  id={`tramite_adjuntos_${index}`}
                                  name={`tramite.adjuntos.${index}`}
                                  label={adjunto?.documento?.nombre}
                                  value={adjunto?.archivo}
                                  onChange={handleArchivoChange(index)}
                                  fileName={adjunto?.documento?.codigo}
                                  isInvalid={isInvalid(
                                    `adjuntos.${index}.archivo`,
                                    tramiteForm,
                                  )}
                                  error={t(
                                    tramiteForm.errors.adjuntos?.[index]
                                      ?.archivo,
                                  )}
                                  disabled={!isFinalizado(tramite)}
                                />
                              )}
                            </Col>
                          </Row>
                          {existeArchivoHistorico(adjunto) &&
                            !isPresentado(tramite) &&
                            !isProcesado(tramite) && (
                              <Row>
                                <Col>
                                  {listarArchivosHistoricos(adjunto).map(
                                    (archivo) => (
                                      <Grid
                                        style={{ fontSize: "50%!important" }}
                                      >
                                        <Row>
                                          <Col lg={10}>
                                            <dl>
                                              <dt>
                                                {[
                                                  new Date(
                                                    archivo?.fechaAlta,
                                                  ).toLocaleDateString(),
                                                  "-",
                                                  archivo?.nombre,
                                                  `(${t(
                                                    "adjuntosForm.archivos.historicos.tramite",
                                                  )} ${archivo?.tramiteAlta})`,
                                                ].join(" ")}
                                              </dt>
                                              <dd>
                                                <small>
                                                  {[
                                                    archivo?.algoritmoChequeo,
                                                    archivo?.chequeo,
                                                  ].join(": ")}
                                                </small>
                                              </dd>
                                            </dl>
                                          </Col>
                                          <Col lg={1}>
                                            <LinkButton
                                              sm
                                              style={{
                                                margin: 0,
                                                fontSize: "16px",
                                              }}
                                              onClick={handleHistoricoClick(
                                                index,
                                                archivo,
                                              )}
                                            >
                                              <UploadIcon />
                                            </LinkButton>
                                          </Col>
                                          <Col lg={1}>
                                            <LinkButton
                                              sm
                                              style={{
                                                margin: 0,
                                                fontSize: "16px",
                                              }}
                                              href={`${ARCHIVOS_ENDPOINT}/${archivo?.id}?token=${token}`}
                                            >
                                              <DownloadIcon />
                                            </LinkButton>
                                          </Col>
                                        </Row>
                                      </Grid>
                                    ),
                                  )}
                                </Col>
                              </Row>
                            )}
                        </Grid>
                      )}
                    </ListGroupItem>
                  ))}
                </ListGroup>
              )}
            </ArrayField>
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
